import axios from 'api';

// /api/super/reference/call-types/
// Backend filterset: { scope: ["exact"] }. Search: name, description.

export const getCallTypeData = (filtersData, signal) => {
  const { page_size, page, search, scope } = filtersData || {};
  const params = new URLSearchParams();
  if (page_size != null) params.set('page_size', page_size);
  if (page != null) params.set('page', page);
  if (search) params.set('search', search);
  if (scope) params.set('scope', scope);
  return axios.get(`/api/super/reference/call-types/?${params.toString()}`, { signal });
};

export const createCallType = (params) => {
  return axios.post(`/api/super/reference/call-types/`, params);
};

export const updateCallType = (params) => {
  return axios.patch(`/api/super/reference/call-types/${params.id}/`, params);
};

export const deleteCallType = (id) => {
  return axios.delete(`/api/super/reference/call-types/${id}/`);
};

export const getAllPublicCallTypes = () => {
  return axios.get(`/api/super/reference/call-types/?page_size=1000`);
};

// ─── Legacy stubs ────────────────────────────────────────────────────────
import { removedStub } from 'api/_legacy';
export const getCustomerCallTypeData = removedStub('getCustomerCallTypeData');
export const createCustomerCallType = removedStub('createCustomerCallType');
export const updateCustomerCallType = removedStub('updateCustomerCallType');
export const deleteCustomerCallType = removedStub('deleteCustomerCallType');
